<div [id]="'filter-box-' + filterName" class="filter-box">
  <div [id]="'section-title-' + filterName" class="title" (click)="toggleSection()">
    {{ title | translate }}
    <ng-container *ngIf="conditionsInfoTemplateRef" [ngTemplateOutlet]="conditionsInfoTemplateRef"></ng-container>
    <ng-container *ngIf="shoesSizeInfoTemplateRef" [ngTemplateOutlet]="shoesSizeInfoTemplateRef"></ng-container>
    <ng-container *ngIf="clothingSizeInfoTemplateRef" [ngTemplateOutlet]="clothingSizeInfoTemplateRef"></ng-container>
    <img class="arrow-expandable" src="assets/images/icons/arrow.svg" [ngClass]="{ expanded: isExpanded }" />
  </div>

  <div class="search-box" *ngIf="isQuickSearchable && isExpanded">
    <form novalidate="" class="search-box-form">
      <input
        autocapitalize="off"
        autocorrect="off"
        spellcheck="false"
        type="text"
        class="search-box-input"
        placeholder="{{ 'Search' | translate }} {{ inputPlaceholder | translate }}..."
        (keyup)="onQuickSearch($event['target']['value'])"
      />
    </form>
  </div>

  <div class="wrap listing-box" [id]="'listing-box-' + filterName" [ngClass]="{ expanded: isExpanded }" *ngIf="options">
    <cdk-virtual-scroll-viewport itemSize="37.36" style="height: 200px; width: 100%">
      <ng-container *cdkVirtualFor="let item of visibleOptions; let i = index">
        <div class="item">
          <ng-container [ngSwitch]="inputType">
            <ng-container *ngSwitchCase="FilterBoxInputTypeEnum.CHECKBOX">
              <label for="{{ filterName }}_{{ i + 1 }}">
                <input
                  type="checkbox"
                  class="checkbox ignore-click-outside"
                  id="{{ filterName }}_{{ i + 1 }}"
                  [value]="item[accessProperty]"
                  [checked]="shouldOptionBeSelected(filterName, item[accessProperty])"
                  (click)="onToggleSectionOption(filterName, $event['target']['value'], 'filter-box-' + filterName)"
                />
                <ng-container *ngIf="filterName === 'color'">
                  <span
                    class="item-color"
                    style="background: var(--{{ item['colorEn'] ? item['colorEn'] : item[accessProperty] }})"
                  ></span>
                </ng-container>
                <div class="text">{{ item[displayProperty] | translate }}</div>
                <span class="tag-count">{{ item['count'] }}</span>
              </label>
            </ng-container>

            <ng-container *ngSwitchCase="FilterBoxInputTypeEnum.RADIOBUTTON">
              <label for="{{ filterName }}_{{ i + 1 }}">
                <input
                  type="radio"
                  class="radio ignore-click-outside"
                  id="{{ filterName }}_{{ i + 1 }}"
                  [name]="filterName"
                  [value]="item[accessProperty]"
                  [checked]="shouldOptionBeSelected(filterName, item[accessProperty])"
                  (click)="onToggleSectionOption(filterName, $event['target']['value'], 'filter-box-' + filterName)"
                />
                <div class="text">{{ item[displayProperty] | translate }}</div>
                <span class="tag-count">{{ item['count'] }}</span>
              </label>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
    </cdk-virtual-scroll-viewport>
  </div>

  <ng-container *ngIf="isExpanded" [ngTemplateOutlet]="priceSliderTemplateRef"></ng-container>
</div>
